import LocationSearchInput from "@/components/LocationSearchInput";
import { Label } from "@/components/ui/label";
import type { Json } from "@/integrations/supabase/types";

interface LocationSelectionFormProps {
  isEditing: boolean;
  address: string;
  onLocationSelect: (location: { 
    lat: number; 
    lng: number; 
    formattedAddress: string;
    placeId?: string;
    businessDetails?: {
      name?: string;
      phoneNumber?: string;
      website?: string;
      rating?: number;
      userRatingsTotal?: number;
      reviews?: google.maps.places.PlaceReview[];
      photoUrl?: string;
    };
  }) => void;
}

const LocationSelectionForm = ({
  isEditing,
  address,
  onLocationSelect,
}: LocationSelectionFormProps) => {
  if (!isEditing) {
    return (
      <div className="space-y-2">
        <Label className="text-gray-700">Business Location</Label>
        <p className="text-gray-600">{address || 'Not set'}</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <Label className="text-gray-700">Business Location</Label>
      <LocationSearchInput 
        onLocationSelect={onLocationSelect}
        defaultValue={address}
      />
    </div>
  );
};

export default LocationSelectionForm;